import React, { memo, useCallback, useState } from "react";
import useAuth from "../../hooks/useAuthContext";
import Modal from "react-bootstrap/Modal";

const ItemMenuModal = memo(({ label, Icon, iconeIm }) => {
  const { usuario } = useAuth();
  const [show, setShow] = useState(false);

  const handleClose = useCallback(() => setShow(false), []);
  const toggleModal = useCallback(() => setShow((prev) => !prev), []);

  const iconeItem = iconeIm ? (
    <img src={iconeIm} alt="" />
  ) : Icon ? (
    <Icon />
  ) : null;

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Pin do usuario</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="menu-modal">{usuario?.pin || "Não informado"}</div>
        </Modal.Body>
        <Modal.Footer>
          <button onClick={handleClose} className="btn btn-header-options">
            Fechar
          </button>
        </Modal.Footer>
      </Modal>

      <button
        type="button"
        className="small-box-footer link-menu menu-item-button"
        onClick={toggleModal}
      >
        <div className="container-item-menu">
          <div className={`item-menu-icone${label ? "-label" : ""}`}>
            {iconeItem}
          </div>
          {label ? <div className="item-menu-label">{label}</div> : null}
        </div>
      </button>
    </>
  );
});

ItemMenuModal.displayName = "ItemMenuModal";

export default ItemMenuModal;
